import * as types from './types';

export const refreshList = () => ({
  type: types.CHANGE_LIST_VERSION
});
